import type { FC, ReactNode } from 'react';
import React from 'react';

import { Textfit } from '@wwe-portal/ui/components/text-fit';

import {
  Dialog,
  DialogCloseButton,
  DialogContent,
} from '@wwe-portal/ui/components/dialog';
import { RewardIcon } from '@wwe-portal/ui/components/icons';
import { cn } from '@wwe-portal/ui/lib/lib';

export interface LoginDialogProps {
  title: ReactNode;
  open: boolean;
  onClose?: () => void;
  loginButtons: React.ReactNode;
  className?: string;
}
export const LoginDialog: FC<LoginDialogProps> = ({
  title,
  open,
  onClose,
  loginButtons,
  className,
}) => {
  return (
    <Dialog
      onOpenChange={(isOpen) => {
        if (!isOpen) onClose?.();
      }}
      open={open}
    >
      <DialogContent
        className={cn(
          'w-[244px] px-5 py-[60px] md:h-[431px] md:w-[420px] md:px-[60px]',
          className
        )}
        data-id="login-dialog"
        variant="message"
      >
        <div className="flex flex-col items-center justify-center">
          <RewardIcon />
          <Textfit className="py-[45px]" max={16} min={16} mode="single">
            {title}
          </Textfit>
          <div className="flex w-[196px] flex-col gap-4 md:w-[300px]">
            {loginButtons}
          </div>
        </div>
        <DialogCloseButton onClose={onClose} />
      </DialogContent>
    </Dialog>
  );
};
